import { gql } from '@apollo/client';

export const MANAGER_HOME_QUERY = gql`
  query ManagerHome {
    managerHome {
      manager {
        userId
        userName
      }
      groups {
        id
        label
      }
      projects {
        id
        ruleId
        name
        groupLabel
        groupId
        purpose
        endDate
        createdAt
        section
        totalCount
        completeCount
        approvedCount
        lastActivityAt
        graderCount
        isMultiGrader
        codeTypes
        rubricId
        graders {
          id
          firstName
          lastName
          assignedVolume
          totalCount
          completedCount
        }
      }
    }
  }
`;

export const GET_QARULE_BY_ID = gql`
  query QaruleById($id: String) {
    QaruleById(id: $id) {
      data
    }
  }
`;

export const ARCHIVE_PROJECT_MUTATION = gql`
  mutation ArchiveProject($id: String!, $qarule: qaruleInput!) {
    UpdateQarule(id: $id, qarule: $qarule) {
      id
    }
  }
`;

export const UPDATE_QARULE = gql`
  mutation UpdateQarule($id: String, $qarule: qaruleInput!) {
    UpdateQarule(id: $id, qarule: $qarule) {
      id
    }
  }
`;
